import { IDamagesClaims } from '../models/damages-claims/damages-claims.interface';

export const initialDamagesClaimsValues: IDamagesClaims = {
  shipmentNumber: '',
  nplClaim: '',
  origin: { id: '', contacts: [] },
  destination: { id: '', contacts: [] },
  claiminTheAmount: undefined,
  dateFiled: undefined,
  nplTrack: '',
  claimantsClaim: undefined,
  billofLading: '',
  claimantsName: '',
  claimantsAddress: '',
  dateOfLossDamage: undefined,
  locationOfLossDamage: '',
  claimHereByFiledFor: {
    isShortage: false,
    isOverage: false,
    isDamage: false,
    isOther: false
  },
  carrier: { id: '', contacts: [] },
  contacts: undefined,
  pickupReadyDate: undefined,
  pickupCloseDate: undefined,
  deliveryReadyDate: undefined,
  deliveryCloseDate: undefined,
  detailedStatement: '',
  totalAmountClaimed: undefined,
  claimValueBasedOn: {
    isFullInvoiceValue: false,
    isRepair: false,
    isAllowance: false
  },
  forgoingStatement: {
    claimantsRep: '',
    claimantsSignature: '',
    date: undefined,
    telephone: '',
    fax: '',
    email: '',
    salesPerson: ''
  },
  documentReferenceTypeId: '',
  documentReferenceNumber: '',
  document: null
};
